export const Collection = Object.freeze({
  Users: 'users',
  WorkRequests: 'work-requests',
  Shifts: 'shifts',
  GazettedHolidays: 'gazetted-holiday',
  TimesheetLogs: 'timesheet-logs',
  DeviceTokens: 'device-tokens',
})
